import React from "react";
import styled from "styled-components";

interface Props {
  label: string;
  selectedValue: string;
  onRadioButtonChange: (value: string) => void;
  disabled?: boolean;
  options: { label: string; value: string; child?: React.ReactNode }[];
}

const RadioButtonsContainer = styled.div`
  margin: 10px;
  cursor: pointer;
  white-space: nowrap;
`;

const StyledInput = styled.input`
  cursor: pointer;
  :focus {
    border: solid var(--color-bg-tertiery);
  }
`;
const FlexContainer = styled.div`
  display: flex;
  margin-bottom: 1.2em;
  flex-direction: column;
`;

const Label = styled.div`
  font-size: 1em;
  margin-top: 2em;
  text-align: center;
`;

const RadioButtons = ({
  label,
  selectedValue,
  onRadioButtonChange,
  disabled,
  options,
}: Props) => {
  return (
    <div>
      <Label>{label}</Label>
      <FlexContainer>
        {options.map((o) => (
          <RadioButtonsContainer
            key={o.value}
            onClick={() => onRadioButtonChange(o.value)}
          >
            <StyledInput
              type="radio"
              name={o.label}
              value={o.value}
              checked={selectedValue === o.value}
              onChange={() => onRadioButtonChange(o.value)}
              disabled={disabled}
            />
            {o.child ?? o.label}
          </RadioButtonsContainer>
        ))}
      </FlexContainer>
    </div>
  );
};
export default RadioButtons;
